__turbopack_context__.v({
  "eyebrow": "EcommerceDevelopmentServicesCardSection-module__UbXbhW__eyebrow",
  "heading": "EcommerceDevelopmentServicesCardSection-module__UbXbhW__heading",
  "section": "EcommerceDevelopmentServicesCardSection-module__UbXbhW__section",
  "title": "EcommerceDevelopmentServicesCardSection-module__UbXbhW__title",
});
